import React from "react";
import { useHistory, useLocation } from "react-router-dom/cjs/react-router-dom";

import Header from "../../components/Header";
import ListaUsuarios from "./ListaUsuarios";
import ListaConcessionarias from "./ListaConcessionarias";
import ListaGruposDealer from "./ListaGruposDealer";

import "../Usuario/styles.css";
import "./styles.css";

const ABAS = [
  { chave: "usuarios", titulo: "Usuários", rota: "/cadastros" },
  {
    chave: "concessionarias",
    titulo: "Concessionárias",
    rota: "/cadastros/concessionarias",
  },
  {
    chave: "grupos-dealer",
    titulo: "Grupos Dealer",
    rota: "/cadastros/grupos-dealer",
  },
];

/**
 * Menu "Cadastros" (RD 95133): reúne Usuários, Concessionárias e Grupos Dealer
 * em abas, mantendo o mesmo padrão visual da antiga tela de Usuários.
 */
export default function Cadastros() {
  const history = useHistory();
  const { pathname } = useLocation();

  const abaAtiva =
    ABAS.slice(1).find((aba) => pathname.startsWith(aba.rota))?.chave ??
    "usuarios";

  return (
    <>
      <Header mostrarPesquisar={false} />
      <div className="container cadastros-page">
        <h1 className="cadastros-title">Cadastros</h1>

        <div className="cadastros-tabs">
          {ABAS.map((aba) => (
            <button
              key={aba.chave}
              type="button"
              className={`cadastros-tab ${
                abaAtiva === aba.chave ? "active" : ""
              }`}
              onClick={() => history.push(aba.rota)}
            >
              {aba.titulo}
            </button>
          ))}
        </div>

        <section className="cadastros-content">
          {abaAtiva === "usuarios" && <ListaUsuarios />}
          {abaAtiva === "concessionarias" && <ListaConcessionarias />}
          {abaAtiva === "grupos-dealer" && <ListaGruposDealer />}
        </section>
      </div>
    </>
  );
}
